import { ChangeDetectionStrategy, Component, Input, ElementRef } from "@angular/core";

import { CarouselElementSlideService } from "./carousel-element-slide/carousel-element-slide.service";

export type CarouselElementType = "white-blue" | "white-grey" | "blue-white" | "grey-white";

@Component({
  selector: "carousel-element",
  templateUrl: "./carousel-element.component.html",
  styleUrls: ["./carousel-element.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselElement {
  /** Types of styles for the carousel */
  @Input() type: CarouselElementType = "white-blue";

  get slides() {
    return this.carouselElementSlideService.getSlides(this.elementRef.nativeElement);
  }

  constructor(
    private readonly elementRef: ElementRef,
    private readonly carouselElementSlideService: CarouselElementSlideService
  ) {}
}
